import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import SignUp from "./SignUp";
import { Button } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

function SignUpModal({ open, onClose, language, history, auth, settings }) {
  const excludedPaths = ["/profile", "/checkout/details"];
  if (excludedPaths.includes(history.location.pathname)) return <></>;
  if (
    !settings.enable_social_auth ||
    !settings.enable_social_auth_staff ||
    auth.user
  )
    return <></>;
  return (
    <div>
      <Dialog
        onClose={() => onClose()}
        aria-labelledby="simple-dialog-title"
        open={open}
        PaperProps={{
          style: {
            width: "90%",
            height: 400,
          },
        }}
      >
        <ClearIcon
          style={{
            position: "absolute",
            top: 15,
            right: language == "english" && 15,
            left: language == "arabic" && 15,
          }}
          onClick={() => onClose()}
        />
        <DialogTitle id="simple-dialog-title" className="text-center">
          <span className="bold">
            {language == "english" ? "Sign up" : "التسجيل"}
          </span>
        </DialogTitle>
        <SignUp
          onContinueAsGuest={() => {
            onClose();
          }}
          signUpExtraAction={() => onClose()}
        />
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    auth: state.auth,
  };
};
export default withRouter(connect(mapStateToProps)(SignUpModal));
